@if (accessDenied(); as denied) {
  <div class="hc-app-auth-error" data-testid="auth-access-denied">
    <div class="hc-app-auth-error-inner">
      <img class="hc-app-auth-error-logo" alt="Hypecast" src="assets/logos/HYPECASTdefault.svg" />
      <h3 class="hc-app-auth-error-title">{{ 'AuthAccessDenied.Title' | translate }}</h3>
      <p class="hc-app-auth-error-text">{{ 'AuthAccessDenied.Text' | translate }}</p>
      @if (accessDeniedDetails(); as details) {
        <p class="hc-app-auth-error-details" data-testid="auth-access-denied-details">
          {{ 'AuthAccessDenied.Details' | translate: { description: details } }}
        </p>
      }
      <button
        (click)="signInWithDifferentAccount()"
        [disabled]="switchingAccount()"
        class="hypecast-primary-button"
        data-testid="auth-access-denied-switch-account"
        type="button"
      >
        {{ 'AuthAccessDenied.SwitchAccount' | translate }}
      </button>
    </div>
  </div>
} @else if (authFailed()) {
  <div class="hc-app-auth-error">
    <div class="hc-app-auth-error-inner">
      <img class="hc-app-auth-error-logo" alt="Hypecast" src="assets/logos/HYPECASTdefault.svg" />
      <h3 class="hc-app-auth-error-title">We could not complete your sign-in</h3>
      <p class="hc-app-auth-error-text">
        Your session could not be established. Signing in again normally resolves this.
      </p>
      <button type="button" class="hypecast-primary-button" (click)="retryLogin()">Sign in again</button>
    </div>
  </div>
} @else if (tenant() === null) {
  <div class="hc-app-splash">
    <div class="hc-app-splash-inner">
      <img class="hc-app-splash-logo" alt="Hypecast" src="assets/logos/HYPECASTdefault.svg" />
      <div class="hc-app-splash-bar">
        <div class="hc-app-splash-bar-fill"></div>
      </div>
    </div>
  </div>
} @else {
  <router-outlet />
}
